import BigNumber from 'bignumber.js'
import { cva } from 'class-variance-authority'

import { formatHealthFactor } from '@/domain/common/format'
import { healthFactorToRiskLevel } from '@/domain/common/risk'
import { cn } from '@/ui/utils/style'
import { testIds } from '@/ui/utils/testIds'

import { Typography } from '../typography/Typography'

interface HealthFactorBadgeProps {
  hf: BigNumber | undefined
  className?: string
  size?: 'small' | 'default'
  truncateLarge?: boolean
}

const badgeVariants = cva('rounded-[8px] border', {
  variants: {
    variant: {
      liquidation: 'border-red-400/30 bg-red-400/15 text-red-400',
      risky: 'border-red-400/30 bg-red-400/15 text-red-400',
      moderate: 'border-amber-400/30 bg-amber-400/15 text-amber-400',
      healthy: 'border-teal-400/30 bg-teal-400/15 text-teal-400',
      'no debt': 'border-teal-400/30 bg-teal-400/15 text-teal-400',
      unknown: 'bg-muted',
    },
    size: {
      small: 'px-2',
      default: 'px-4 py-1',
    },
  },
  defaultVariants: {
    size: 'default',
  },
})

export function HealthFactorBadge({ hf, className, size = 'default', truncateLarge = false }: HealthFactorBadgeProps) {
  const riskLevel = healthFactorToRiskLevel(hf)

  return (
    <div className={cn(badgeVariants({ variant: riskLevel, size }), className)}>
      <Typography
        variant="span"
        className={cn('text-inherit', size === 'small' && 'text-xs leading-5')}
        data-testid={testIds.component.HealthFactorBadge.value}
      >
        {formatHealthFactor(hf, { truncateLarge })}
      </Typography>
    </div>
  )
}
